// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".q-header input[type=text],.q-header input[type=text]:not(.browser-default){width:150px;text-align:left}.pp-interaction-title input{box-sizing:border-box;max-width:100%}.darkTheme{color:#fff}.pastSessionTime{pointer-events:none}.feedback-container{clear:both}", ""]);
// Exports
module.exports = exports;
